import { call, put } from "redux-saga/effects";
import { Creators } from ".";
import { api, ResponseError } from "../../services";

export default function* getRolesList() {
  try {
    const response = yield call(api.getRolesList);

    yield put(Creators.getRolesListSuccess(response));
  } catch (response) {
    const errorResponse = new ResponseError(response);
    errorResponse.alertMessage();
    yield put(Creators.getRolesListFailure());
  }
}
